import React from "react";
import {Image} from "semantic-ui-react";

const VehicleCard = ({vehicle, updateVehicleStatus, setCurrentCard}) => {
    const [name = "", cardNumber = ""] = vehicle?.name_of_vehicle?.split("-") || [];
    return <div className="vehicle-card">
        <div className="flex-row-between">
            <div className="flex-row">
                <Image src="/images/creditCardMockup.svg"/>
                <div>
                    <p className="text-regular-xl">Card ending in: <span
                        className="text-bold">{cardNumber}</span></p>
                    <p className="text-regular-sm">{name}</p>
                </div>
            </div>
            {vehicle.enroll_code !== 'enrolled' && <div className="flex-gap-center">
                <button className="enroll-vehicle-btn" onClick={() => setCurrentCard(vehicle)}>Enroll Vehicle
                </button>
                {vehicle.enroll_code === 'pending' && <button
                    onClick={() => updateVehicleStatus({vehicle: vehicle, enroll_code: "later"})}
                    className="enroll-later-btn">Enroll Later</button>}
            </div>}
            {vehicle.enroll_code === 'enrolled' && <div className="tag-success">
                <span>Assigned</span>
                <span>&#10003;</span>
            </div>
            }
        </div>
        {!['spare', 'enrolled'].includes(vehicle.enroll_code) &&
            <>
                <hr className="divider"/>
                <div className="mark-spare-card"
                     onClick={() => updateVehicleStatus({vehicle: vehicle, enroll_code: "spare"})}>
                    Mark as spare card
                </div>
            </>
        }
        {vehicle.enroll_code === 'enrolled' && <>
            <hr className="divider"/>
            <div className="flex-row">
                {vehicle.dashboard_mobile_url && <img src={vehicle.dashboard_mobile_url} alt="vehicle" width="60" height="45" className="border-rounded"/>}
                <div>
                    <p className="text-medium-sm">{vehicle.year} {vehicle.make} {vehicle.model}</p>
                    {vehicle?.miles && <p className="text-muted-sm">{vehicle?.miles?.toLocaleString()} miles</p>}
                </div>
            </div>

        </>
        }
    </div>
}

export default VehicleCard;
